import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "50vh",
    padding: "3rem 2rem",
    textAlign: "center",
  },
  title: {
    marginTop: "1em",
    marginBottom: ".5em",
  },
  text: { margin: 0 },
  ctaContainer: {
    bottom: 0,
    width: "100%",
    padding: "32px 8px",
    boxSizing: "border-box",
    "@media (min-width: 480px)": {
      width: "480px",
    },
  },
  btn: {
    width: "100%",
    backgroundColor: "#1C75BC",
    padding: "10px 16px",
    fontSize: "1.125rem",
    fontWeight: 600,
    color: "#FFFFFF",
    border: 0,
    borderRadius: 6,
    cursor: "pointer",
  },
});
